import { render, staticRenderFns } from "./SettingsIndexesList.vue?vue&type=template&id=48d1a76e&scoped=true&"
import script from "./SettingsIndexesList.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexesList.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIndexesList.vue?vue&type=style&index=0&id=48d1a76e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48d1a76e",
  null
  
)

export default component.exports